import React from 'react';
import { useSelector } from 'react-redux';
import AvatarUser from './AvatarUser';

function Account({ color = '#000' }) {
  const user = useSelector(({ auth }) => auth.user);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
      }}
    >
      <AvatarUser />

      <div className="accountTexts" style={{ fontSize: '14px', textAlign: 'left', marginLeft: '8px' }}>
        <div
          style={{
            color,
            fontWeight: '600',
            paddingBottom: '2px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '140px',
          }}
        >
          {user.name}
        </div>
        <div style={{ color: 'rgb(255 255 255 / 71%)' }}>
          <p
            style={{
              margin: 0,
              fontSize: '12px',
              color: '#808080',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '140px',
            }}
          >
            {user.email}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Account;
